

<script setup lang="ts">

const props = defineProps<{
  style: any,
  apiData: any,
  property: any,
}>();

const backgroundColor = ref(props.style.backgroundColor);

const tabActiveColor = ref(props.style.tabActiveColor ? props.style.tabActiveColor : '#000');
const tabDisabledColor = ref(props.style.tabDisabledColor ? props.style.tabDisabledColor : '#000');

// CSS 변수로 전달할 스타일 값들
const cssVars = computed(() => ({
  '--tab-active-color': tabActiveColor.value,
  '--tab-disabled-color': tabDisabledColor.value
}));



const type = ref(props.property.type);
const title = ref();
const data = ref(props.apiData);

const headContentsData = ref({
  title : '-',
  value : '-',
  unit : '-',
  contents : [],
});

const contentsData = ref();

// headContentsData를 업데이트하는 함수
const updateHeadContentsData = () => {
  if(type.value === 'single'){
    headContentsData.value = {
      title : props.property.head.title ?? '-',
      value : data.value ? data.value[props.property.head.name] : '-',
      unit : props.property.head.unit,
      contents : [],
    }
  } else if(type.value === 'tab'){
    headContentsData.value = props.property.contents.map((v: any) => {
      return  {
        title : v.head.title ?? '-',
        value : data.value ? data.value[v.head.name] : '-',
        unit : v.head.unit,
        contents: v.contents.map((content: any) => {
          return  {
            title : content.title ?? '-',
            name : content.name,
            unit : content.unit,
          }
        })
      }
    })
  }
};

onMounted(() => {
  if(type.value === 'single'){
    title.value = props.property.title;
    contentsData.value = props.property.contents;
  } else if(type.value === 'tab'){
    title.value = props.property.contents.map((v: any) => v.title);
  }
  
  // 초기 headContentsData 설정
  updateHeadContentsData();
});

// apiData가 변경될 때마다 headContentsData 업데이트
watch(() => props.apiData, (newApiData) => {
  data.value = newApiData;
  updateHeadContentsData();
}, { deep: true });

</script>

<template>
  <div class="total-prod-card common-card">
    <div class="card-wrapper" :style="{background: backgroundColor}" v-if="type === 'single'">
      <div class="title">
        <slot name="title"></slot>
         {{ commonUtils.isAllStrDataEmpty(title) }}
      </div>
      <div class="content-wrapper">
        <div class="head-content">
          <div class="d-flex content-area">
            <div class="head-content-wrapper">
              <span>{{ commonUtils.isAllStrDataEmpty(headContentsData.title) }}</span>
              <!-- <span>{{ commonUtils.isAllStrDataEmpty(headContentsData.value) }}</span> -->
              <span>{{ commonUtils.unitFormatter(headContentsData.value, headContentsData.unit, 1).value }}</span>
            </div>
            <span class="head-content-unit">{{ commonUtils.unitFormatter(headContentsData.value, headContentsData.unit, 1).unit }}</span>
          </div>        
        </div>
        <div class="content">
          <div class="d-flex content-area" v-for="content in contentsData" :key="content.title">
            <div class="in-content-wrapper">
              <span>{{ commonUtils.isAllStrDataEmpty(content.title) }}</span>
              <!-- <span>{{ commonUtils.isAllStrDataEmpty(apiData ? apiData[content.name] : '-') }}</span> -->
               <span>{{ apiData ? commonUtils.unitFormatter(apiData[content.name], content.unit, 1).value : '-' }}</span>
            </div>
            <span class="in-content-unit">{{ commonUtils.unitFormatter(apiData[content.name], content.unit, 1).unit }}</span>
          </div>
        </div>
      </div>
    </div>

    <div class="tab-wrapper card-wrapper" :style="{background: backgroundColor, ...cssVars}" v-else-if="type === 'tab'">
      <div class="title">
        <ul class="nav nav-pills nav-fill mb-3" id="pills-tab" role="tablist">
          <li class="nav-item" role="presentation" v-for="(title, idx) in title" :key="title">
            <button :class="`nav-link ${idx === 0 ? 'active' : ''}`" :id="`pills-${idx}-tab`" data-bs-toggle="pill" :data-bs-target="`#pills-${idx}`" type="button" role="tab" :aria-controls="`pills-${idx}`" aria-selected="true" 
            >{{ title }}</button>
          </li>
        </ul>
      </div>
      <div class="content-wrapper tab-content" id="nav-tabContent">
        <div :class="`tab-pane fade ${idx === 0 ? 'show active' : ''}`" v-for="(data, idx) in headContentsData" :id="`pills-${idx}`" role="tabpanel" :aria-labelledby="`pills-${idx}-tab`" tabindex="0">
          <div class="head-content">
            <div class="d-flex content-area">
              <div class="head-content-wrapper">
                <span>{{ commonUtils.isAllStrDataEmpty(data.title) }}</span>
                <!-- <span>{{ commonUtils.isAllStrDataEmpty(headContentsData.value) }}</span> -->
                <span>{{ commonUtils.unitFormatter(data.value, data.unit, 1).value }}</span>
              </div>
              <span class="head-content-unit">{{ commonUtils.unitFormatter(data.value, data.unit, 1).unit }}</span>
            </div>        
          </div>
          <div class="content">
            <div class="d-flex content-area" v-for="content in data.contents" :key="content.title">
              <div class="in-content-wrapper">
                <span>{{ commonUtils.isAllStrDataEmpty(content.title) }}</span>
                <!-- <span>{{ commonUtils.isAllStrDataEmpty(apiData ? apiData[content.name] : '-') }}</span> -->
                <span>{{ apiData ? commonUtils.unitFormatter(apiData[content.name], content.unit, 1).value : '-' }}</span>
              </div>
              <span class="in-content-unit">{{ commonUtils.unitFormatter(apiData[content.name], content.unit, 1).unit }}</span>
            </div>
          </div>
        </div>
      </div>
    </div>

  </div>
</template>

<style lang="scss" scoped>
@use "@/assets/styles/design-toc/total-prod-card.scss";
@use "@/assets/styles/design-toc/define.scss";
@use "@/assets/styles/design-toc/common-card.scss";

.nav-link {
  background: var(--tab-disabled-color);
  border-bottom-left-radius: 0;
  border-bottom-right-radius: 0;
  border-bottom: 1px solid #313131 !important;
  &.active {
    background: var(--tab-active-color);
    border-bottom: 1px solid var(--tab-active-color) !important;
  }
}

.common-card {
  padding: 0.5rem !important;
}

.total-prod-card .card-wrapper {
  border-radius: 6px;
}
</style>